import React, { useEffect, useState } from 'react';
import { Button } from "devextreme-react/button";
import useApi from "../../hooks/useApi";
import { useParams } from "react-router-dom";
import MessageBox from '../../components/popups/MessageBox';


export default function Wubook() {
    //interface ConfigResult {
    //    WUBOOK_WIRED_API_KEY: string;
    //    WUBOOK_WIRED_CUSTOMER_ID: string;
    //    WUBOOK_MODE_TEST: string;
    //};

    const { data: message, getData, setData: setmessageText } = useApi<string>(`WuBook`, (''));
    //const [modeTest, setModeTest] = useState(false);
    //const [apiKey, setApiKey] = useState("");

    //const {
    //    getData: getConfig,
    //} = useApi('Configuration');

    //useEffect(() => {
    //    try {
    //        const names = 'WUBOOK_WIRED_API_KEY,WUBOOK_WIRED_CUSTOMER_ID,WUBOOK_MODE_TEST'
    //        getConfig({ customPath: `Configuration/${names}/Config` })
    //            .then((result) => {
    //                console.log(result)
    //                const configResult = result as ConfigResult;

    //                var value = configResult['WUBOOK_MODE_TEST'];
    //                var isTrueSet = (value.toLowerCase() === 'true');
    //                setModeTest(isTrueSet);

    //                var value = configResult['WUBOOK_WIRED_API_KEY'];
    //                setApiKey(value);
    //            })
    //            .catch((err) => console.log(err))
    //    } catch (error) {
    //    }
    //}, [])

    //console.log(dataSourceWuBook);

  return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "1rem", height: "100%", justifyContent: "center" }}>
            <MessageBox buttonType='Ok' isOpen={message!== ''} message={message} title="Manisoft Gestion" onConfirme={() => { setmessageText('') }} onAnnuler={() => { setmessageText('') }} />
            <Button style={{ height: "5rem", width: "10rem" }} onClick={e => {
                getData({
                    customPath: 'WuBook/SynchroUnite'                   
                });}}>
                Sync unite
            </Button>
            <Button style={{ height: "5rem", width: "10rem" }} onClick={e => {
                getData({
                    customPath: 'WuBook/SynchroReservation'
                });}}>
                Sync Disponibilité
            </Button>
            <Button style={{ height: "5rem", width: "10rem" }} onClick={e => {
                getData({
                    customPath: 'WuBook/SynchroRecuperation'
                });}}>
                Sync recupération
            </Button>
        </div>
    );
};
